var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-input", {
    attrs: {
      type: "text",
      placeholder: _vm.placeholder,
      maxlength: _vm.maxLength,
      rows: _vm.rows,
      type: _vm.type,
      size: _vm.size,
      disabled: _vm.disabled,
      "show-word-limit": _vm.showWordLimit,
      clearable: _vm.clearable,
    },
    on: { blur: _vm.blur },
    scopedSlots: _vm._u(
      [
        {
          key: "suffix",
          fn: function () {
            return [_vm._t("suffix")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
    model: {
      value: _vm.bindValue,
      callback: function ($$v) {
        _vm.bindValue = $$v
      },
      expression: "bindValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }